// extracted by mini-css-extract-plugin
module.exports = {"mastering_options_header":"mastering-options-header_mastering_options_header__w12Tb","selected_tab":"mastering-options-header_selected_tab__tcfel"};